import React, {useState, useEffect} from 'react'
import './CardGrid.scss'


export default function CardGrid({changeScore, changeTimer, nbCartesRestantes, tabRobots, niveau}) {
    const [nbCardReverse, setNbCardReverse] = useState(0)
    const [tabCardReverse, setTabCardReverse] = useState([])
    const [firstClick, setFirstClick] = useState(true)

    // si le niveau est pair (2,4,6) on réduit le temps de visibilité des cartes
    const [timeCardReturned, setTimeCardReturned] = useState(() => {
        return (niveau % 2) === 0 ? 800 : 1200
    })

    const handleClick = (e) => {

        // déclencher timer lors du premier click
        if (firstClick) {
            changeTimer()
            setFirstClick(false)
        }

        // retourne la carte si elle n'est pas déjà retourné   
        // et si 0 ou 1 autre carte est retourné en même temps
        if (e.target.parentNode.classList == "card" && nbCardReverse <= 1) {
            retournerCard(e.target.parentNode)
            setNbCardReverse(nbCardReverse + 1)
            setTabCardReverse([...tabCardReverse, e.target.nextSibling])
        }

    }

    const retournerCard = (elmt) => {
        elmt.classList.toggle("retourner");
    }

    const disapearCard = (elmt) => {
        elmt.classList.toggle("disapear");
    }

    const reinitialiserNbCartesRetournes = () => {
        setNbCardReverse(0)
        setTabCardReverse([])
    }

    const check2CardReverse = () => {

        // si 2 cartes sont retournées
        if (nbCardReverse === 2) { 
            
            // vérifie si les 2 cartes sont les mêmes
            if (tabCardReverse[0].classList[1] === tabCardReverse[1].classList[1]) {
                changeScore(50)
                setTimeout(() => { 
                    disapearCard(tabCardReverse[0].parentNode)
                    disapearCard(tabCardReverse[1].parentNode)
                    nbCartesRestantes(-2)
                    reinitialiserNbCartesRetournes()
                }, 800)
            } 
            // si les 2 cartes sont différentes
            else { 
                changeScore(-20)

                setTimeout(() => { 
                    retournerCard(tabCardReverse[0].parentNode)
                    retournerCard(tabCardReverse[1].parentNode)
                    reinitialiserNbCartesRetournes()
                }, timeCardReturned)
                
            }
            
        }
    }

    useEffect(() => {
    
        check2CardReverse()
        
    }, [nbCardReverse])



       // retourner 2 cartes
        // onclick => retourner la carte ✅
        // si 0 ou une seule carte retourné ✅
            // attendre click ✅
            // retourner la carte ✅
        // si 2 cartes sont retournées ✅    
            // si les 2 cartes sont les mêmes ✅
                // rendre invisible les cartes ✅
                // augmenter score +50 ✅
                // réinitialiser nbCardReverse et tabCardReverse ✅
            // sinon ✅
                // retourner les 2 cartes ✅
                // diminuer score -20 ✅
   

    const Cards = tabRobots.map((robot, index) => {
        return (
            <div key={index} className="card" onClick={handleClick}>
                <div className="card--front"></div>
                <div className={`card--back robot${robot}`}></div>
            </div>
        )
    })

  
    return (
        <div className='mainContainer'>
            <div className={`cardGrid cardGrid-niveau${niveau}`}>

                {Cards}
            
            </div>
        </div>
    )
}
